<template>
  <div class="index">
      <div class="index_nav">
        <div class="el-icon-back" @click="toggleReturn()"></div>
        <div class="nav_title">{{course_title}}</div>
      </div>
      <el-tag type="success">{{notice}}</el-tag>

      <!--    -->
      <div class="index_centent">
        <div class="centent_left">
          <transition enter-active-class="animate__animated animate__fadeInLeft" leave-active-class="animate__animated animate__fadeOutLeft">
            <div class="centent_left_keep" v-show="catalog_show">
              <div class="keep_box">
                  <div class="keep_box_list" v-for="(item,index) in catalog" :key="index">
                    <div class="list_title">{{item.name}}</div>
                    <div class="list_name" :class="[listQuery.file_id===t.id?'active':'']" v-for="(t,cindex) in item.course" :key="cindex" @click="Clickplay(t,item,cindex,index)">
                      <div class="list_name_a">
                        <div class="el-icon-video-camera-solid"></div>
                        <div class="list_name_cent">{{t.name}}</div>
<!--                        <div class="list_name_status">-->
<!--                        <template  v-if="listQuery.file_id===t.id">-->
<!--                          <div>正在学</div>-->
<!--                        </template>-->
<!--                        <template v-else>-->
<!--                          <template v-if="t.courselog!==null">-->
<!--                            <div v-if="t.courselog.status===1">已完成</div>-->
<!--                            <div v-else>待完成</div>-->
<!--                          </template>-->
<!--                          <template v-else>-->
<!--                            <div>未观看</div>-->
<!--                          </template>-->
<!--                        </template>-->
<!--                        </div>-->
                      </div>
                      <div class="list_name_b">
                        <div class="time">时长：{{t.duration | times}}</div>
                        <div style="margin-right: 10px;"> | </div>
                        <template v-if="t.courselog!==null">
                          <div v-if="t.courselog.status===1" style="color: #67c23a;">已完成</div>
                          <div v-else style="color: #f56c6c;">待完成</div>
                        </template>
                        <template v-else>
                          <div>未观看</div>
                        </template>
                        <div class="dq_status" v-if="listQuery.file_id===t.id">正在学习</div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </transition>
            <div class="catalog" @click.stop="toggleCatalog()">
              <div class="el-icon-s-unfold"></div>
              <div class="name">章节</div>
            </div>
          <div class="centent_num">
            <div class="name">要求课时</div>
            <div class="num">{{complete_num}}</div>
            <div class="name">已选课时</div>
            <div class="num">{{play_num.length}}</div>
            <div class="name">已完成课时</div>
            <div class="num">{{play_complete.length}}</div>
          </div>
        </div>
        <div class="player-container">
          <my-video ref="mychild" :videoSrc="src" :isFast="isFast" :logTime="logtime" @getNextSection="getNextSection" @userCourseByOver="userCourseByOver" @postuserCourselog="postuserCourselog"></my-video>
        </div>
        <div class="centent_right">
          <div class="instructions">
            <div class="title">学习验证</div>
            <div class="video_box">
              <img class="ta_video" v-if="photo!=null" :src="photo.face" />
              <div style="color: #3ab06f;font-size: 12px;" v-else>提示：当前观看视频暂未开始拍照认证，等待弹出拍照提示后进行认证。</div>
            </div>
            <div class="title">验证须知</div>
            <div class="desc">进行拍照验证时，请将摄像头对准五官，无遮挡，清楚露出五官，准确无误后点击拍照验证进行采集人脸。</div>
          </div>
        </div>
      </div>


      <!--     如果是ie浏览器 遮挡    -->
      <div class="ie" v-if="is_support">
        <div class="ie_hint">IE浏览器无法支持课程播放功能，请更换谷歌浏览器或360浏览器(12.0及以上版本)观看。</div>
      </div>

      <!--     如果是微信浏览器 遮挡    -->
      <div class="ie" v-if="is_support_wx">
        <div class="ie_hint">微信浏览器无法支持课程播放功能，请更换谷歌浏览器或360浏览器(12.0及以上版本)观看。</div>
      </div>

      <!--     如果是微信浏览器 遮挡    -->
      <div class="ie" v-if="is_support_app">
        <div class="ie_hint">请在PC上打开链接，同时使用谷歌浏览器或360浏览器(12.0及以上版本)观看；IE浏览器无法支持课程播放功能。</div>
      </div>


      <div class="ie" v-if="!is_facility">
        <div class="ie_hint">系统未检测到摄像头,无法进行学习验证,请先安装摄像头后，重新进入学习！</div>
      </div>


    <!--   弹出拍照区 -->
<!--    <div class="phontShow" v-show="phont_show">-->
<!--      <div class="box">-->
<!--        <div class="instructions">-->
<!--          <div class="title">学习验证</div>-->
<!--          <div class="video_box">-->
<!--            <video ref="video" class="ta_video"  autoplay></video>-->
<!--            <div class="taking" @click="togglePhotograph()">-->
<!--              <template  v-if="taking_show">-->
<!--                <i class="el-icon-camera-solid"></i>点击拍照验证-->
<!--              </template>-->
<!--              <template  v-else>-->
<!--                <i class="el-icon-camera-solid"></i>请稍等，提交中..-->
<!--              </template>-->
<!--            </div>-->
<!--            <canvas ref="canvas" v-show="false" width="240" height="200"></canvas>-->
<!--          </div>-->
<!--          <div class="title1">验证须知</div>-->
<!--          <div class="desc">进行拍照验证时，请将摄像头对准五官，无遮挡，清楚露出五官，准确无误后点击拍照验证进行采集人脸。</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->



    <!--  人脸识别区域  -->

    <div class="phontShow" v-show="identify_show">
      <div class="rl_box">
        <div class="instructions">
          <div class="title">人脸识别</div>
          <div class="video_box">
            <video ref="video" class="ta_video"  autoplay></video>
            <div class="taking" @click="togglePhotographOss()">
              <template  v-if="taking_identify_show">
                <i class="el-icon-camera-solid"></i>点击人脸识别
              </template>
              <template  v-else>
                <i class="el-icon-camera-solid"></i>正在识别比对..
              </template>
            </div>
            <canvas ref="canvas" v-show="false" width="190" height="230"></canvas>
          </div>
          <div class="title1">人脸识别须知</div>
          <div class="desc">1.进行人脸识别时，请将摄像头对准五官，无遮挡，清楚露出五官，准确无误后点击拍照验证进行采集人脸。</div>
          <div class="desc" style="color: red;font-weight: 500;">2.请保证光线充足，采集的容貌要清晰可辨，否则将会影响考试。</div>
          <div class="desc" style="color: red;font-weight: 500;">3.请衣着整洁，请勿出现光膀子，不穿上衣等不雅情况，否则将会影响考试。</div>
        </div>
      </div>
    </div>




  </div>
</template>

<script>
    import { Base64 } from 'js-base64';
    import axios from 'axios'
    import myconfig from '@/config'
    import oss from '@/utils/aliOss'
  import MyVideo from '@/components/MyVideo/Index'
  import {GetItemByData,PostUserCourseByOver,GetUserCourseByLog,PostUserFaceByPhoto,PostFaceRecognition,GetShutDownStatus} from '@/api/new/course'
    export default {
        name: "videos",
        filters: {
            times(duration) {
                let times = Math.floor(duration / 60) + ':' + ((duration % 60) / 100).toFixed(2).slice(-2);
                return times;
            }
        },
        data(){
            return{
                end_time:null,//培训播放结束时间
                notice:'当前视频观看超过2分钟时，将开始计算课时，并将加入已选课时后,提交播放记录；如当前学习视频观看未满2分钟，当你点击观看其他视频则不将当前视频加入已选课时中。',
                identify_show:true,//人脸识别
                taking_identify_show:true,
                status:2,//当前播放课程的完成状态
                sign_id:null,//当前用户报名id
                issue_id:null,//期号id
                inst_id:null,//机构id
                photo:null,//当前小节验证照片
                taking_show:true,
                currentTime:0,
                is_switch:true,//开关
                is_mandatory:1,//是否强制课程 1.默认强制  2普通课程
                phont_show:false,
                course_id:null,
                catalog_id:null,
                catalog:[],
                course_title:null,
                logtime:0,
                indexQuery: {
                    tindex: 0,
                    index: 0,
                },
                listQuery: {
                    id: undefined,
                    user_id: undefined,
                    file_id:null
                },
                is_support: false, //判断是否是ie浏览器
                is_support_wx:false,  //判断是否是微信浏览器
                is_support_app:false, //判断是否是手机浏览器
                is_facility: true,//摄像头是否存在
                id:null,
                catalog_show:false,//左侧目录
                isFast:2,//是否允许快进 1.允许 2.不允许
                src:"",
                is_course_log:true,
                complete_num:null,  ///当前期号对应完成数
                open_num:null,  ///可观看视频数
                play_num:[], //当前期号对应用户的播放记录
                play_complete:[],//当前课程已完成课时
                Initialize_src:'',//初始化的时候的src
                type: 4, //提交验证的类型
            }
        },
        mounted() {
            //手机浏览器打开
            if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                this.is_support_app = true
                return
            }
            //微信浏览器
            let ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                this.is_support_wx = true
            }
            //判断是否IE浏览器
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                // alert("IE浏览器暂不支持播放，请更换谷歌浏览器或360浏览器观看。");
                this.is_support = true
            }
            //判断摄像头是否存在
            this.checkshebei()
            //调用摄像头
            this.callCamera()

        },
        components:{
            MyVideo,
        },
        created() {
            this.listQuery.id = this.$route.query.c_id
            this.issue_id = this.$route.query.issue_id
            this.sign_id = this.$route.query.sign_id
            this.inst_id = this.$route.query.inst_id
            this.getlist()
        },
        updated(){
            //监听是否最小化
            this.minimize()
        },
        methods:{
            //监听是否最小化
            minimize(){
                //IE
                let that = this
                if(document.addEventListener){
                    document.addEventListener('msvisibilitychange',function(){
                        console.log(document.msVisibilityState);
                        if(ocument.msVisibilityState=="visible"){
                            ////游览器处于最大化
                        }else{
                            //游览器处于最小化
                            that.$refs.mychild.pauseVideo();
                        }
                    })
                }
                //火狐
                if(document.addEventListener){
                    document.addEventListener('mozvisibilitychange',function(){
                        if(document.mozVisibilityState=="visible"){
                            //游览器处于最大化
                        }else{
                            //游览器处于最小化
                            that.$refs.mychild.pauseVideo();
                        }
                    })
                }
                //谷歌
                if(document.addEventListener){
                    document.addEventListener('webkitvisibilitychange',function(){
                        console.log(document.webkitVisibilityState);
                        if(document.webkitVisibilityState=="visible"){
                            //游览器处于最大化
                        }else{
                            //游览器处于最小化
                            that.$refs.mychild.pauseVideo();
                        }
                    })
                }
            },
            //base64转blob
            dataURLtoBlob(dataurl) {
                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            },
            //将blob转换为file
            blobToFile(theBlob, fileName) {
                theBlob.lastModifiedDate = new Date();
                theBlob.name = fileName;
                return theBlob;
            },
            //oss直传
            togglePhotographOss(){
                let that = this;
                let type = that.type
                let user = JSON.parse(localStorage.getItem('userinfo'));
                if (!that.is_facility) {
                    that.$alert('您没有没有拍摄设备', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.$router.go(-1)
                        }
                    });
                    return
                }
                if(user.card_img==null || user.card_img==''){
                    that.$alert('请您先前往个人中心个人信息上传一寸照片', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.$router.go(-1)
                        }
                    });
                    return
                }
                that.taking_identify_show = false
                let ctx = this.$refs['canvas'].getContext('2d')
                // 把当前视频帧内容渲染到canvas上
                // ctx.drawImage(this.$refs['video'], 0, 0, 240, 200)
                ctx.drawImage(this.$refs['video'], 0, 0, 190, 230)
                // 转base64格式、图片格式转换、图片质量压缩
                let imgBase64 = this.$refs['canvas'].toDataURL('image/jpeg', 0.8)
                // 由字节转换为KB 判断大小
                let str = imgBase64.replace('data:image/jpeg;base64,', '')
                let strLength = str.length
                let fileLength = parseInt(strLength - (strLength / 8) * 2)
                // 图片尺寸  用于判断
                var _blob = this.dataURLtoBlob(imgBase64);
                let suffix = imgBase64.split(';')[0].split(':')[1].split('/')[1];//文件扩展名
                var filename = String(new Date().getTime())+'.'+suffix;
                var _file = this.blobToFile(_blob, filename);
                const op = oss.ossUploadFile(_file)
                op.then(res => {
                    //提交当前照片进行识别
                    var temp = {
                        cur_time: parseInt(that.currentTime),
                        file_id: that.listQuery.file_id,
                        course_id: that.course_id,
                        issue_id:that.issue_id,
                        autonym_id:user.id,
                        sign_id:that.sign_id,
                        type:type
                    }
                    let imageUrl = myconfig.VUE_APP_BASE_IMG_OSS + res.url
                    temp.base = imageUrl
                    let urla = imageUrl
                    let urlb = user.card_img
                    let url = 'https://go.10huisp.com/face/GetContrastImgs?urla='+ urla + '&urlb='+ urlb +'';
                    let FaceUrl = 'https://gozhuzhong.10huisp.com/v1/training/trainingTopic/GetFaceVivisectionUrl?url='+ urla;
                    axios.get(FaceUrl).then(res=>{
                      if(res.data.code==20000){
                        // that.$message.success(res.msg);
                        axios.get(url).then(response => {
                          if(response.data.code==10001){
                            that.taking_identify_show = true
                            that.$message.warning('人脸识别不通过，请重新识别！');
                            return
                          }
                          let Confidence = response.data.Data.Confidence
                          temp.RequestId = response.data.RequestId
                          //超过61就可以认为是同一个人。
                          if(Confidence>61){
                            that.identify_show = false
                            that.taking_identify_show = true
                            if(type==4){
                              that.init()
                            }
                            if(type==3){
                              setTimeout(function () {
                                that.$refs.mychild.playVideo();
                              }, 150)
                            }
                            PostFaceRecognition(temp).then(res=>{
                              if(type==3 && res.code==20000){
                                let status_index = parseInt(that.indexQuery.index);
                                let status_tindex = parseInt(that.indexQuery.tindex);
                                that.catalog[status_index].course[status_tindex].photos = res.data
                                that.photo = res.data
                                setTimeout(function () {
                                  that.is_switch = true
                                }, 2000)
                              }
                            })
                            //提交通过人脸的照片信息
                            that.$message.success('人脸识别已通过,请开始学习');
                          }
                          else {
                            that.taking_identify_show = true
                            that.$message.warning('人脸识别不通过，请重新识别！');
                            return
                          }
                        })
                      }else {
                        console.log(res.data.msg,"res.msg")
                        that.taking_identify_show = true
                        that.$message.warning(res.data.msg);
                        return
                      }
                    })

                })
            },
            init(){
                let that = this
                that.src = that.Initialize_src
            },
            //点击拍照
            //暂定每个视频中间弹出验证
            //拍照的时候需要暂停视频，并且提示用户进行拍照验证操作
            togglePhotograph(){
                let that = this;
                if (!that.is_facility) {
                    that.$message.warning('没有拍摄设备');
                    return
                }
                that.taking_show = false
                let ctx = this.$refs['canvas'].getContext('2d')
                // 把当前视频帧内容渲染到canvas上
                // ctx.drawImage(this.$refs['video'], 0, 0, 240, 200)
                ctx.drawImage(this.$refs['video'], 0, 0, 190, 230)
                // 转base64格式、图片格式转换、图片质量压缩
                let imgBase64 = this.$refs['canvas'].toDataURL('image/jpeg', 0.7)
                // 由字节转换为KB 判断大小
                let str = imgBase64.replace('data:image/jpeg;base64,', '')
                let strLength = str.length
                let fileLength = parseInt(strLength - (strLength / 8) * 2)
                // 图片尺寸  用于判断
                var _blob = this.dataURLtoBlob(imgBase64);
                let suffix = imgBase64.split(';')[0].split(':')[1].split('/')[1];//文件扩展名
                var filename = String(new Date().getTime())+'.'+suffix;
                var _file = this.blobToFile(_blob, filename);
                const op = oss.ossUploadFile(_file)
                op.then(res => {
                    //提交当前照片进行识别
                    let user = JSON.parse(localStorage.getItem('userinfo'));
                    var temp = {
                        base: myconfig.VUE_APP_BASE_IMG_OSS + res.url,
                        course_id: that.course_id,
                        file_id: that.listQuery.file_id,
                        user_id: null,
                        cur_time: parseInt(that.currentTime),
                        issue_id:that.issue_id,
                        autonym_id:user.id,
                        sign_id:that.sign_id,
                    }
                    PostUserFaceByPhoto(temp).then(res=>{
                        if(res.code==20000){
                            let status_index = parseInt(that.indexQuery.index);
                            let status_tindex = parseInt(that.indexQuery.tindex);
                            that.catalog[status_index].course[status_tindex].photos = res.data
                            that.photo = res.data
                            //提交人脸认证
                            that.taking_show = true
                            that.phont_show = false
                            setTimeout(function () {
                                that.$refs.mychild.playVideo();
                            })
                            setTimeout(function () {
                                that.is_switch = true
                            }, 2000)
                            this.$message({
                                message: '认证提交成功！',
                                type: 'success'
                            });
                        }
                        else{
                            this.$notify({
                                title: '提示',
                                message: '提交失败，请重新认证',
                                type: 'warning'
                            });
                            that.taking_show = true
                            that.is_switch = true
                        }
                    })
                })


            },
            //课程断点
            postuserCourselog(currentTime,duration){
                let that = this
                that.currentTime = currentTime


                //已完成的课程允许快进
                let isFast =  that.isFast
                //that.listQuery.file_id 完成的课程允许快进。
                //我已经知道当前课程的id ,那么我要查到当前课程的
                let status_index = parseInt(that.indexQuery.index);
                let status_tindex = parseInt(that.indexQuery.tindex);
                //允许完成的视频快进
                that.isFast = 2
                if (that.catalog[status_index].course[status_tindex].courselog != null) {
                    if(that.catalog[status_index].course[status_tindex].courselog.status==1){
                        that.isFast = 1
                    }
                }

                //提交断点
                //未满2分钟不提交记录
                if(parseInt(currentTime)>= 120){
                  if(parseInt(currentTime) % 30 == 0 && that.is_course_log){


                      let end_time = that.end_time; //培训结束时间
                      let times_tamp = parseInt(new Date().getTime() / 1000);	//到秒
                      if(times_tamp>=end_time){
                          that.$refs.mychild.pauseVideo();
                          this.$alert('当前课程培训时间已结束，您无法继续学习。', '提示', {
                              confirmButtonText: '确定',
                              callback: action => {
                                  that.$router.go(-1)
                              }
                          });
                          return
                      }


                      //加已选记录  //走两分钟后才开始计算时长。
                      let play_num = that.play_num; //当前已选课程
                      let complete_num = that.complete_num;
                      let open_num = that.open_num;
                      let paly_index = play_num.indexOf(that.listQuery.file_id);
                      if (paly_index < 0) {
                          if (play_num.length < open_num) {
                              that.play_num.push(that.listQuery.file_id);
                          }
                      }

                      if (that.catalog[status_index].course[status_tindex].courselog == null) {
                          that.catalog[status_index].course[status_tindex].courselog = {
                              status:2,
                              logtime:0,
                          }
                      }
                      else{
                          console.log(that.catalog[status_index].course[status_tindex].courselog,"2")
                          if(that.catalog[status_index].course[status_tindex].courselog.status == 2){
                              that.catalog[status_index].course[status_tindex].courselog.logtime = currentTime
                          }
                      }


                    that.is_course_log = false
                    let user = JSON.parse(localStorage.getItem('userinfo'));
                    let temp = {
                        logtime: parseInt(currentTime),
                        user_id: null,
                        course_id: that.course_id,
                        file_id: that.listQuery.file_id,
                        issue_id:that.issue_id,
                        autonym_id:user.id,
                        sign_id:that.sign_id,
                        inst_id:that.inst_id,
                    }

                    GetUserCourseByLog(temp).then(res => {
                        setTimeout(function () {
                            that.is_course_log = true
                        }, 2000)
                    })
                }
                }

                //检测拍照验证
                //that.info.is_mandatory  1.强制课程，需要拍照  2.普通课程，不需要
                //判断当前课程是否已拍照，查询当前是否存在当前课程视频验证。
                //

                let dus = duration/2;
                let c = parseInt(currentTime);
                let d = parseInt(dus);
                let is_switch = that.is_switch //开关
                let photo = that.photo //如果已拍照，不再弹出
                //属于强制课程，需拍照
                if(that.is_mandatory==1 && photo==null){
                    if(c==d && is_switch){
                        that.is_switch = false
                        // that.phont_show = true
                        that.identify_show = true
                        that.type = 3
                        //退出全屏
                        if (document.exitFullScreen) {
                            document.exitFullScreen();
                        } else if (document.mozCancelFullScreen) {
                            document.mozCancelFullScreen();
                        } else if (document.webkitExitFullscreen) {
                            document.webkitExitFullscreen();
                        } else if (document.msExitFullscreen) {
                            document.msExitFullscreen();
                        }
                        that.$refs.mychild.pauseVideo();
                    }
                }
            },
            //监听播放完成后修改当前视频状态
            videoStatus(){
                let that = this
                let catalog_id = that.catalog_id;
                let course = [];
                let cindex = 0;
                let play_complete = that.play_complete;
                for (let i=0;i<that.catalog.length;i++){
                    if(that.catalog[i].id==catalog_id){
                        course = that.catalog[i].course
                        cindex = i
                        break
                    }
                }
                let index = parseInt(that.indexQuery.index)
                let tindex = parseInt(that.indexQuery.tindex)

                if(course.length>0){
                    if(tindex<course.length-1){
                        //给当前视频更新本地完成记录
                        if(that.catalog[index].course[tindex].courselog==null){
                            that.catalog[index].course[tindex].courselog = {
                                status:1,
                            }
                        }
                        else {
                            that.catalog[index].course[tindex].courselog.status = 1
                        }
                        let id = that.catalog[index].course[tindex].id
                        let play_complete_index = play_complete.indexOf(id);
                        if(play_complete_index<0){
                            that.play_complete.push(id);
                        }
                    }
                    //当前目录已结束，切换下一个新目录第一个视频
                    if(tindex==course.length-1){
                        //给当前视频更新本地完成记录
                        if(that.catalog[cindex].course[tindex].courselog==null){
                            that.catalog[cindex].course[tindex].courselog = {
                                status:1,
                            }
                        }
                        else {
                            that.catalog[cindex].course[tindex].courselog.status = 1
                        }
                        let id = that.catalog[cindex].course[tindex].id
                        let play_complete_index = play_complete.indexOf(id);
                        if(play_complete_index<0){
                            that.play_complete.push(id);
                        }
                    }
                }
            },
            //下一节
            getNextSection(){
                let that = this
                let catalog_id = that.catalog_id;
                let course = [];
                let cindex = 0;

                let play_num = that.play_num
                let complete_num = that.complete_num
                let open_num = that.open_num
                let play_complete = that.play_complete
                for (let i=0;i<that.catalog.length;i++){
                    if(that.catalog[i].id==catalog_id){
                        course = that.catalog[i].course
                        cindex = i
                        break
                    }
                }

                let index = parseInt(that.indexQuery.index)
                let tindex = parseInt(that.indexQuery.tindex)
                if(course.length>0){
                    if(tindex<course.length-1){
                        let info = course[tindex+1]
                        let info_x = course[tindex]

                        //给当前视频更新本地完成记录
                        if(that.catalog[index].course[tindex].courselog==null){
                            that.catalog[index].course[tindex].courselog = {
                                status:1,
                            }

                            let play_complete_index = play_complete.indexOf(info_x.id);
                            if(play_complete_index<0){
                                that.play_complete.push(info_x.id);
                            }
                        }
                        else {
                            that.catalog[index].course[tindex].courselog.status = 1

                            let play_complete_index = play_complete.indexOf(info_x.id);
                            if(play_complete_index<0){
                                that.play_complete.push(info_x.id);
                            }
                        }

                        that.logtime = 0;
                        if(info.courselog!=null && info.courselog.status==2){
                            //如果当前课程存在播放记录，那么获取当前的播放记录；2.并且为未完成的课程
                            that.logtime = info.courselog.logtime;
                        }



                        let paly_index = play_num.indexOf(info_x.id);
                        if(paly_index<0){
                            //如果是不存在的，那么就需要判断当前记录是否已经达标
                            if(play_num.length>=open_num){
                                that.$alert('学习课时数量已达到上限，您只能学习待完成与已完成的视频，如果您想继续学习未观看的新视频，请联系培训机构继续观看剩余课程', '提示', {
                                    confirmButtonText: '确定',
                                    callback: action => {
                                        that.$message({
                                            type: 'success',
                                            message: '已知晓'
                                        });
                                    }
                                });
                                return;
                            }
                        }
                        that.src = info.url
                        that.photo = info.photos //当前验证图片
                        that.listQuery.file_id = info.id
                        that.listQuery.course_id = that.course_id
                        that.indexQuery.tindex = tindex+1
                        that.indexQuery.index = index

                    }
                  //当前目录已结束，切换下一个新目录第一个视频
                    if(tindex==course.length-1){
                        let info = that.catalog[cindex+1].course[0]
                        let info_x = that.catalog[cindex].course[0];
                        // let info = that.catalog[index+1].course[0]
                        //给当前视频更新本地完成记录
                        if(that.catalog[cindex].course[tindex].courselog==null){
                            that.catalog[cindex].course[tindex].courselog = {
                                status:1,

                            }
                            // let play_complete_index = play_complete.indexOf(info.id);
                            // if(play_complete_index<0){
                            //     that.play_complete.push(info.id);
                            // }
                            let play_complete_index = play_complete.indexOf(info_x.id);
                            if(play_complete_index<0){
                                that.play_complete.push(info_x.id);
                            }
                        }
                        else {
                            that.catalog[cindex].course[tindex].courselog.status = 1
                            // let play_complete_index = play_complete.indexOf(info.id);
                            // if(play_complete_index<0){
                            //     that.play_complete.push(info.id);
                            // }
                            let play_complete_index = play_complete.indexOf(info_x.id);
                            if(play_complete_index<0){
                                that.play_complete.push(info_x.id);
                            }
                        }

                        that.logtime = 0;
                        if(info.courselog!=null && info.courselog.status==2){
                            //如果当前课程存在播放记录，那么获取当前的播放记录；2.并且为未完成的课程
                            that.logtime = info.courselog.logtime;
                            that.status = 2
                        }
                        // let paly_index = play_num.indexOf(info.id)
                        let paly_index = play_num.indexOf(info_x.id);
                        if(paly_index<0){
                            //如果是不存在的，那么就需要判断当前记录是否已经达标
                            if(play_num.length>=open_num){
                                that.$alert('学习课时数量已达到上限，您只能学习待完成与已完成的视频，如果您想继续学习未观看的新视频，请联系培训机构继续观看剩余课程', '提示', {
                                    confirmButtonText: '确定',
                                    callback: action => {
                                        that.$message({
                                            type: 'success',
                                            message: '已知晓'
                                        });
                                    }
                                });
                                return;
                            }
                            if(play_num.length<open_num){
                                // that.play_num.push(info.id)
                                that.play_num.push(info_x.id)
                            }
                        }
                        that.src = info.url
                        that.photo = info.photos //当前验证图片
                        that.catalog_id =  info.catelog_id
                        that.listQuery.file_id = info.id
                        that.listQuery.course_id = that.course_id
                        that.indexQuery.tindex = 0
                        that.indexQuery.index = index+1
                    }
                }
            },
            //播放结束，提交数据
            userCourseByOver(currentTime,type){
                let that = this
                let user = JSON.parse(localStorage.getItem('userinfo'));
                //退出全屏
                if (document.exitFullScreen) {
                    document.exitFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }


                this.videoStatus()
                that.status = 1
                //修改这门课的id
                var temp = {
                    logtime: currentTime,
                    user_id: null,
                    course_id: that.course_id,
                    file_id: that.listQuery.file_id,
                    issue_id:that.issue_id,
                    autonym_id:user.id,
                    sign_id:that.sign_id,
                    inst_id:that.inst_id,
                }
                PostUserCourseByOver(temp).then(res=>{
                    if(type==1){
                        if(res.code==20000){
                            this.$message({
                                message: '恭喜你，播放记录提交成功,继续学习吧！',
                                type: 'success'
                            });
                            this.$refs.mychild.Suloading();
                        }
                        else {
                            this.$message({
                                message: '提交失败，请重新提交',
                                type: 'warning'
                            });
                            this.$refs.mychild.Suloading();
                        }
                    }
                    if(res.code==10001){
                        this.$notify({
                            title: '提示',
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                })
            },
            //检测摄像头是否存在
            checkshebei() {
                let that = this;
                if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
                    navigator.enumerateDevices = function (callback) {
                        navigator.mediaDevices.enumerateDevices().then(callback);
                    };
                }
                var MediaDevices = [];
                var isHTTPs = location.protocol === 'https:';
                var canEnumerate = false;
                if (typeof MediaStreamTrack !== 'undefined' && 'getSources' in MediaStreamTrack) {
                    canEnumerate = true;
                } else if (navigator.mediaDevices && !!navigator.mediaDevices.enumerateDevices) {
                    canEnumerate = true;
                }
                var hasMicrophone = false;
                var hasSpeakers = false;
                var hasWebcam = false;
                var isMicrophoneAlreadyCaptured = false;
                var isWebcamAlreadyCaptured = false;
                function checkDeviceSupport(callback) {
                    if (!canEnumerate) {
                        return;
                    }
                    if (!navigator.enumerateDevices && window.MediaStreamTrack && window.MediaStreamTrack.getSources) {
                        navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(window.MediaStreamTrack);
                    }
                    if (!navigator.enumerateDevices && navigator.enumerateDevices) {
                        navigator.enumerateDevices = navigator.enumerateDevices.bind(navigator);
                    }
                    if (!navigator.enumerateDevices) {
                        if (callback) {
                            callback();
                        }
                        return;
                    }
                    MediaDevices = [];
                    navigator.enumerateDevices(function (devices) {
                        devices.forEach(function (_device) {
                            var device = {};
                            for (var d in _device) {
                                device[d] = _device[d];
                            }
                            if (device.kind === 'audio') {
                                device.kind = 'audioinput';
                            }
                            if (device.kind === 'video') {
                                device.kind = 'videoinput';
                            }
                            var skip;
                            MediaDevices.forEach(function (d) {
                                if (d.id === device.id && d.kind === device.kind) {
                                    skip = true;
                                }
                            });
                            if (skip) {
                                return;
                            }
                            if (!device.deviceId) {
                                device.deviceId = device.id;
                            }
                            if (!device.id) {
                                device.id = device.deviceId;
                            }
                            if (!device.label) {
                                device.label = 'Please invoke getUserMedia once.';
                                if (!isHTTPs) {
                                    device.label = 'HTTPs is required to get label of this ' + device.kind + ' device.';
                                }
                            } else {
                                if (device.kind === 'videoinput' && !isWebcamAlreadyCaptured) {
                                    isWebcamAlreadyCaptured = true;
                                }
                                if (device.kind === 'audioinput' && !isMicrophoneAlreadyCaptured) {
                                    isMicrophoneAlreadyCaptured = true;
                                }
                            }
                            if (device.kind === 'audioinput') {
                                hasMicrophone = true;
                            }
                            if (device.kind === 'audiooutput') {
                                hasSpeakers = true;
                            }
                            if (device.kind === 'videoinput') {
                                hasWebcam = true;
                            }
                            MediaDevices.push(device);
                        });
                        if (callback) {
                            callback();
                        }
                    });
                }
                checkDeviceSupport(function () {
                    if (hasWebcam == false) {
                        that.$notify({
                            title: '提示',
                            message: '系统未检测到摄像头,无法进行学习验证,请先安装摄像头！',
                            duration: 0
                        });
                        that.is_facility = false
                        return false;
                    } else {

                    }
                });
            },
            // 调用摄像头
            callCamera() {
                let that = this;
                if (that.is_facility === false) {
                    that.$message.warning('系统未检测到摄像头,无法进行学习验证,请先安装摄像头！');
                    return
                }
                this.is_camera = false
                this.is_video = true
                // H5调用电脑摄像头API
                navigator.mediaDevices.getUserMedia({
                    video: true
                }).then(success => {
                    // 摄像头开启成功
                    this.$refs['video'].srcObject = success
                    // // 实时拍照效果
                    this.$refs['video'].play()
                })
            },
            toggleCatalog(){
                this.catalog_show = !this.catalog_show
            },
            //返回上一页
            toggleReturn(){
                this.$router.go(-1)
            },
            getlist(){
                let that = this
                let user = JSON.parse(localStorage.getItem('userinfo'));
                let listQuery = that.listQuery
                listQuery.autonym_id = user.id
                listQuery.issue_id = that.issue_id
                listQuery.sign_id = that.sign_id

                GetItemByData(listQuery).then(res=>{
                    let data=Base64.decode(res.data)
                    data=JSON.parse(data);
                    let catalog = data.catalog
                    //查询当前期号是否已被关闭
                    if(data.class_status==2){
                        that.$refs.mychild.pauseVideo();
                        this.$alert('当前课程培训时间已结束，您无法继续学习。', '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                that.$router.go(-1)
                            }
                        });
                        return
                    }
                    that.catalog = catalog
                    that.course_id = data.id
                    that.is_mandatory = data.is_mandatory
                    that.play_num = data.play_num //当前期号对应用户的播放记录
                    that.play_complete = data.play_complete; //当前期号已完成数
                    that.complete_num = data.complete_num //当前期号对应完成要求课时
                    that.open_num = data.open_num //可观看课时数
                    that.end_time = data.end_time //培训结束时间

                    let timestamp = parseInt(new Date().getTime() / 1000);	//到秒
                    if(timestamp>=data.end_time){
                        that.$refs.mychild.pauseVideo();
                        this.$alert('当前课程培训时间已结束，您无法继续学习。', '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                that.$router.go(-1)
                            }
                        });
                        return
                    }

                    //存在播放目录
                    if (catalog.length > 0) {
                        let curselog = data.curselog
                        if(curselog!==null){
                            if (curselog.logtime) {

                                that.logtime = curselog.logtime; //当前时间
                                //播放记录，如果当前状态为1，
                                //并且播放时长小与视频时长3秒，那么从头播放。
                                if(curselog.status==1){
                                    //判断时长
                                    if(curselog.course.duration==curselog.logtime || (curselog.course.duration*1-curselog.logtime*1)<3){
                                        that.logtime = 0; //
                                    }
                                }

                                that.Initialize_src = curselog.course.url  //这个属于临时src,因为现在每次进入都需要先人脸，那么就不能直接播放视频了。
                                // that.src = curselog.course.url//当前视频
                                that.catalog_id = curselog.course.catelog_id //当前播放记录目录层id
                                that.course_title = data.name
                                that.listQuery.file_id = curselog.file_id//当前视频文件
                                that.listQuery.course_id = data.id//当前课程
                                that.photo = curselog.photos //当前验证图片
                                that.status = curselog.status //当前课程的记录状态
                                that.indexQuery.index = data.index
                                that.indexQuery.tindex = data.tindex
                            } else {
                                console.log("进来2")
                                that.Initialize_src = curselog.course.url  //这个属于临时src,因为现在每次进入都需要先人脸，那么就不能直接播放视频了。
                                // that.src = curselog.course.url
                                that.catalog_id = curselog.course.catelog_id //当前播放记录目录层id
                                that.course_title = data.name
                                that.logtime = curselog.logtime
                                that.listQuery.file_id = curselog.file_id
                                that.listQuery.course_id = data.id//当前课程
                                that.photo = curselog.photos //当前验证图片
                                that.status = curselog.status //当前课程的记录状态
                                that.indexQuery.index = data.index
                                that.indexQuery.tindex = data.tindex
                            }
                        }
                        else {
                            //没有播放记录，默认第一个视频
                            that.Initialize_src = catalog[0].course[0].url  //这个属于临时src,因为现在每次进入都需要先人脸，那么就不能直接播放视频了。
                            // that.src = catalog[0].course[0].url
                            that.catalog_id = catalog[0].id
                            that.course_title = data.name
                            that.listQuery.file_id = catalog[0].course[0].id
                            that.listQuery.course_id = data.id//当前课程
                            that.status = 2 //当前课程的记录状态
                        }
                    }
                    else {
                        //没有播放记录，默认第一个视频
                        that.Initialize_src = catalog[0].course[0].url  //这个属于临时src,因为现在每次进入都需要先人脸，那么就不能直接播放视频了。
                        // that.src = catalog[0].course[0].url
                        that.catalog_id = catalog[0].id
                        that.course_title = data.name
                        that.listQuery.file_id = catalog[0].course[0].id
                        that.listQuery.course_id = data.id//当前课程
                        that.status = 2 //当前课程的记录状态
                    }
                })
            },
            //判断上一个视频是否是完成的状态，
            Judgebeing(){
                let that = this
                let catalog_id = that.catalog_id;
                let course = [];
                let cindex = 0;
                for (let i=0;i<that.catalog.length;i++){
                    if(that.catalog[i].id==catalog_id){
                        course = that.catalog[i].course
                        cindex = i
                        break
                    }
                }
                let index = parseInt(that.indexQuery.index)
                let tindex = parseInt(that.indexQuery.tindex)

                if(course.length>0){
                    if(tindex<course.length-1){
                        //给当前视频更新本地完成记录
                        if(that.catalog[index].course[tindex].courselog==null){
                            that.status = 2
                        }
                        else {
                            that.status = that.catalog[cindex].course[tindex].courselog.status
                        }
                    }
                    //当前目录已结束，切换下一个新目录第一个视频
                    if(tindex==course.length-1){
                        //给当前视频更新本地完成记录
                        if(that.catalog[cindex].course[tindex].courselog==null){
                            that.status = 2
                        }
                        else {
                            that.status = that.catalog[cindex].course[tindex].courselog.status
                        }
                    }
                }
            },
            //判断当前课程是否已被关闭。
            toggleClassStatus(){
                let that = this;
                let issue_id = that.issue_id;
                GetShutDownStatus(issue_id).then(res=>{
                    if(res.code==20000){
                      if(res.data==2){
                          that.$refs.mychild.pauseVideo();
                          this.$alert('当前课程培训时间已结束，您无法继续学习。', '提示', {
                              confirmButtonText: '确定',
                              callback: action => {
                                  that.$router.go(-1)
                              }
                          });
                          return
                      }
                    }
                })
            },
            //点击单个视频
            Clickplay(e, row, tindex, index){
                let that = this;
                let end_time = that.end_time; //培训结束时间
                let times_tamp = parseInt(new Date().getTime() / 1000);	//到秒
                if(times_tamp>=end_time){
                    that.$refs.mychild.pauseVideo();
                    this.$alert('当前课程培训时间已结束，您无法继续学习。', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            that.$router.go(-1)
                        }
                    });
                    return
                }


                that.toggleClassStatus()
                let file_id = that.listQuery.file_id
                if(file_id==e.id){
                    return
                }
                // this.Judgebeing()
                let courselog = that.catalog[index].course[tindex].courselog


                let play_num = that.play_num
                let complete_num = that.complete_num
                let open_num = that.open_num
                let paly_index = play_num.indexOf(e.id)
                if(paly_index<0){
                    //如果是不存在的，那么就需要判断当前记录是否已经达标
                    if(play_num.length>=open_num){
                        that.$alert('学习课时数量已达到上限，您只能学习待完成与已完成的视频，如果您想继续学习未观看的新视频，请联系培训机构继续观看剩余课程', '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                that.$message({
                                    type: 'success',
                                    message: '已知晓'
                                });
                            }
                        });
                        // that.status = s_status
                        return;
                    }
                }


                if (that.is_facility === false) {
                    this.$notify({
                        title: '警告',
                        message: '系统未检测到摄像头,无法进行学习验证,请安装摄像头！',
                        type: 'warning'
                    });
                }

                that.logtime = 0;
                if(e.courselog!=null && e.courselog.status==2){
                    //如果当前课程存在播放记录，那么获取当前的播放记录；2.并且为未完成的课程
                    that.logtime = e.courselog.logtime;
                }
                that.src = e.url
                that.photo = e.photos //当前验证图片
                that.listQuery.file_id = e.id
                that.listQuery.course_id = row.coures_id
                that.catalog_id = e.catelog_id

                that.indexQuery.tindex = tindex
                that.indexQuery.index = index
                that.catalog_show = false//左侧目录
            }
        }
    }
</script>

<style lang="scss" scoped>
.index{
  .phontShow{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.8);
    z-index: 999;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .box{
      margin: auto;
      width: 400px;
      border-radius: 10px;
      background-color: #fff;
      .instructions{
        color: #fff;
        width: 100%;
        display: flex;
        flex-direction: column;
        .video_box{
          margin: 20px auto;
          .ta_video{
            margin: 0 auto;
            /*width: 300px;*/
            /*height: 220px;*/
            width: 190px;
            height: 230px;
            object-fit: cover;
          }
        }
        .title{
          margin-bottom: 6px;
          font-weight: 700;
          font-size: 14px;
          color: #333;
          padding: 10px;
        }
        .title1{
          font-weight: 700;
          font-size: 14px;
          color: #333;
          padding: 0 10px;
        }
        .desc{
          font-size: 12px;
          white-space: pre-line;
          color: #3ab06f;
          padding: 10px;
        }
      }
    }
    .rl_box{
      margin: auto;
      width: 600px;
      border-radius: 10px;
      background-color: #fff;
      .instructions{
        color: #fff;
        width: 100%;
        display: flex;
        flex-direction: column;
        .video_box{
          margin: 20px auto;
          .ta_video{
            margin: 0 auto;
            /*width: 300px;*/
            /*height: 220px;*/
            width: 190px;
            height: 230px;
            object-fit: cover;
          }
        }
        .title{
          margin-bottom: 6px;
          font-weight: 700;
          font-size: 14px;
          color: #333;
          padding: 10px;
        }
        .title1{
          font-weight: 700;
          font-size: 14px;
          color: #333;
          padding: 0 10px;
        }
        .desc{
          font-size: 12px;
          white-space: pre-line;
          color: #3ab06f;
          padding: 5px 10px;
        }
      }
    }
  }
  .ie {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ffffff;
    z-index: 999999;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #eee;
    .ie_hint{
      margin: 0 20px;
      font-size: 20px;
    }
  }
  .index_nav{
    background-color: #fff;
    height: 60px;
    border-bottom: 1px solid #eee;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #333;
    .el-icon-back{
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 25px;
      cursor: pointer;
      color: #999;
      margin-right: 10px;
      &:hover{
        background-color: #f1f3f5;
      }
    }
    .nav_title{
      font-weight: bold;
      font-size: 17px;
    }
  }
  .taking{
    background-color: #3ab06f;
    color: #fff;
    width: 130px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    text-align: center;
    border-radius: 5px;
    margin: 10px auto;
    font-weight: normal;
    cursor: pointer;
    &:hover{
      opacity: 0.8;
    }
  }
}
@media screen and (max-width: 1920px) {
  .index_centent{
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 750px;
    .centent_left{
      width: 5%;
      height:100%;
      background-color: #1c1f21;
      position: relative;
      .centent_left_keep{
        position: absolute;
        left: 100%;
        top: 0;
        bottom: 0;
        height:100%;
        background-color: #26292c;
        width: 400px;
        z-index: 999;
        color: #fff;
        overflow: hidden;
        .keep_box{
          height: 730px;
          padding: 20px 15px;
          width: 380px;
          overflow-y: auto;
          .keep_box_list{
            .list_title{
              font-size: 15px;
              font-weight: bold;
            }
            .list_name{
              margin-left: 10px;
              margin-bottom: 15px;
              margin-top: 15px;
              font-size: 13px;
              color: #9e9fa0;
              cursor: pointer;
              .list_name_a{
                display: flex;
                flex-direction: row;
                align-items: center;
                .el-icon-video-camera-solid{
                  font-size: 16px;
                }
                .list_name_cent{
                  margin: 0 5px;
                  /*width: 295px;*/
                  white-space:nowrap;
                  overflow:hidden;
                  text-overflow:ellipsis;
                }
                .list_name_status{
                  font-size: 12px;
                }
              }
              .list_name_b{
                margin-top: 10px;
                display: flex;
                flex-direction: row;
                align-items: center;
                position: relative;
                font-size: 12px;
                .dq_status{
                  position: absolute;
                  right: 15px;
                  top: 0;
                  padding: 2px 10px;
                  border-radius: 3px;
                  color: #fff;
                  background: #3a8ee6;
                }
                .time{
                  margin-right: 10px;
                }
              }
              &:hover{
                color: #3ab06f;
              }
            }
            .list_name.active{
              color: #3ab06f;
            }
          }
        }
      }
      .catalog{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: auto;
        height: 70px;
        color: #a4a5a6;
        cursor: pointer;
        &:hover{
          background-color: #26292c;
          color: #ffffff;
        }
        .el-icon-s-unfold{
          font-size: 28px;
        }
        .name{
          font-size: 14px;
        }
      }
      .centent_num{
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #fff;
        font-size: 14px;
        margin-top: 5px;
        .num{
          margin: 5px 0;
          color: #67c23a;
          font-weight: bold;
          font-size: 18px;
        }
      }
    }
    .player-container{
      width: 75%;
      height:100%;
    }
    .centent_right{
      width: 20%;
      height:100%;
      background-color: #333;
      .instructions{
        padding: 0 20px;
        margin: 20px auto;
        color: #fff;
        .video_box{
          margin: 20px 0;
          .ta_video{
            /*width: 300px;*/
            /*height: 220px;*/
            width: 190px;
            height: 230px;
            object-fit: cover;
          }
        }
        .title{
          margin-bottom: 6px;
          font-weight: 700;
          font-size: 14px;
        }
        .desc{
          font-size: 12px;
          line-height: 24px;
          color: rgba(255,255,255,.6);
          white-space: pre-line;
        }
      }
    }
  }
}
@media screen and (max-width: 1300px) {
  .index_centent{
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 480px;
    .centent_left{
      width: 5%;
      height:100%;
      background-color: #333;
      position: relative;
      .centent_left_keep{
        position: absolute;
        left: 100%;
        top: 0;
        bottom: 0;
        height:100%;
        background-color: #26292c;
        width: 400px;
        z-index: 999;
        color: #fff;
        overflow: hidden;
        .keep_box{
          height: 460px;
          padding: 20px 15px;
          width: 380px;
          overflow-y: auto;
          .keep_box_list{
            .list_title{
              font-size: 15px;
              font-weight: bold;
            }
            .list_name{
              margin-left: 10px;
              margin-bottom: 15px;
              margin-top: 15px;
              font-size: 13px;
              color: #9e9fa0;
              cursor: pointer;
              .list_name_a{
                display: flex;
                flex-direction: row;
                align-items: center;
                .el-icon-video-camera-solid{
                  font-size: 16px;
                }
                .list_name_cent{
                  margin: 0 5px;
                  /*width: 295px;*/
                  white-space:nowrap;
                  overflow:hidden;
                  text-overflow:ellipsis;
                }
                .list_name_status{
                  font-size: 12px;
                }
              }
              .list_name_b{
                margin-top: 10px;
                display: flex;
                flex-direction: row;
                align-items: center;
                position: relative;
                font-size: 12px;
                .dq_status{
                  position: absolute;
                  right: 15px;
                  top: 0;
                  padding: 2px 10px;
                  border-radius: 3px;
                  color: #fff;
                  background: #3a8ee6;
                }
                .time{
                  margin-right: 10px;
                }
              }
              &:hover{
                color: #3ab06f;
              }
            }
            .list_name.active{
              color: #3ab06f;
            }
          }
        }

      }
      .catalog{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: auto;
        height: 70px;
        color: #a4a5a6;
        cursor: pointer;
        &:hover{
          background-color: #26292c;
          color: #ffffff;
        }
        .el-icon-s-unfold{
          font-size: 28px;
        }
        .name{
          font-size: 14px;
        }
      }
    }
    .player-container{
      width: 75%;
      height:100%;
    }
    .centent_right{
      width: 20%;
      height:100%;
      background-color: #333;
      .instructions{
        padding:  0 20px;
        margin: 20px auto;
        color: #fff;
        .video_box{
          margin: 20px 0;
          .ta_video{
            /*width: 220px;*/
            /*height: 180px;*/
            width: 190px;
            height: 230px;
            object-fit: cover;
          }
        }
        .title{
          margin-bottom: 6px;
          font-weight: 700;
          font-size: 14px;
        }
        .desc{
          font-size: 12px;
          line-height: 24px;
          color: rgba(255,255,255,.6);
          white-space: pre-line;
        }
      }
    }
  }
}
</style>